import { UtilidadesDataService } from './shared/utilidades-data.service';
import { UtilidadesConfig } from './shared/utilitdades.config.service';
import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  ViewEncapsulation,
  OnDestroy
} from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import {
  CuadroRetencion,
} from '@app/shared';
import { Subject } from 'rxjs';
import { environment } from "@env/environment";
import { FlowService } from '@app/flow/shared/flow.service';
import { DatePipe } from "@angular/common";


// const log = new Logger('ReportsComponent');

@Component({
  selector: 'iw-utilidades',
  templateUrl: './utilidades.component.html',
  styleUrls: ['./utilidades.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [FlowService,
        UtilidadesDataService,
      DatePipe],

})
export class UtilidadesComponent implements OnInit, OnDestroy {
  // Define cuando esta cargando
  isLoading = false;
  // Contiene la lista de datos del cuadro de retencion de documentos
  cuadroControl: CuadroRetencion[];
  // Referencia de la modal
  modalRef: BsModalRef;
  // Contiene los templates de los controles personalizados
  templates = {};
  // contiene la estructura de la tabla
  settings = {};
  // Referencia al template de la modal
  @ViewChild('templateD') private templateCuadroControl: TemplateRef<any>;
 
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();

  constructor(private modalService: BsModalService,
    private uds: UtilidadesDataService
  ) { }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }



  /**
   * Abre la modal con el formulario correspondiente
   *
   * @param type 
   * @memberof UtilidadesComponent
   */
  open(type: any) {
    // Se abre la modal dependiendo de el tipo de visas a abrir
    switch (type) {
      case 'Cuadro de retencion documental':
        const configTable = new UtilidadesConfig();
        this.settings = configTable.settings;
        this.uds.getCuadroDocumental().subscribe(data => {
        this.cuadroControl = data;
        });
        this.modalRef = this.modalService.show(this.templateCuadroControl, { class: "modal-personalized" });
        break;
      default:
        break;
    }
  }

  // Metodo para limpiar los controles al cerrar la modal
  clear(value: any): void {
    this.cuadroControl.length = 0;
  }
}


// WEBPACK FOOTER //
// ./src/app/utilidades/utilidades.component.ts